export default __webpack_public_path__ + "static/media/plants.2048c2e5.jpg";